import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function getGCalTwoWaySyncSettings(): Promise<{
  name_format: string;
  enabled: boolean;
}> {
  const res = await fetchOrchidAPI(
    "/api/scheduler_calendar_integrations/gcal_two_way_sync",
  );
  if (!res.ok) {
    throw new Error(`failed to get: ${getErrorDetail(await res.text())}`);
  }
  return res.json();
}
